module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/48.7d45a309.png";